module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-large-top uk-container uk-container-center"
  }, [_c('div', {
    staticClass: "uk-grid",
    attrs: {
      "data-uk-grid-margin": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-medium-1-1"
  }, [_c('div', {
    staticClass: "uk-grid"
  }, [_c('div', {
    staticClass: "uk-width-medium-1-4"
  }, [_c('ul', {
    staticClass: "uk-tab uk-tab-left uk-width-medium-1-1",
    attrs: {
      "data-uk-tab": ""
    }
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Buttons'
      }
    }
  }, [_vm._v("按钮")])], 1), _c('li'), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Common'
      }
    }
  }, [_vm._v("通用")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Forms'
      }
    }
  }, [_vm._v("表单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'HtmlEditors'
      }
    }
  }, [_vm._v("富文本编辑器")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Pickers'
      }
    }
  }, [_vm._v("选择器")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Modals'
      }
    }
  }, [_vm._v("对话框")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Tabs'
      }
    }
  }, [_vm._v("分页容器")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dropdowns'
      }
    }
  }, [_vm._v("下拉框列表")])], 1), _vm._v(" "), _c('li', {
    staticClass: "uk-disabled"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Accordions'
      }
    }
  }, [_vm._v("手风琴")])], 1), _vm._v(" "), _c('li', {
    staticClass: "uk-disabled"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Uploaders'
      }
    }
  }, [_vm._v("文件上传")])], 1), _vm._v(" "), _c('li', {
    staticClass: "uk-disabled"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Offcanvas'
      }
    }
  }, [_vm._v("幕布")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-medium-3-4"
  }, [_c('router-view')], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "uk-navbar"
  }, [_c('div', {
    staticClass: "uk-container uk-container-center"
  }, [_c('a', {
    staticClass: "uk-navbar-brand",
    attrs: {
      "href": ""
    }
  }, [_vm._v("V-UIKit")]), _vm._v(" "), _c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/DotNetAge/vue-ui",
      "target": "_blank"
    }
  }, [_vm._v("Github")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/v-uikit"
    }
  }, [_vm._v("NPM")])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-flip"
  }, [_c('ul', {
    staticClass: "uk-navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/DotNetAge/vue-ui/issues",
      "target": "_blank"
    }
  }, [_vm._v("Issues")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.cnblogs.com/ray-liang",
      "target": "_blank"
    }
  }, [_vm._v("My Blog")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f78a6ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 282
// module chunks = 2